const CLIENT_ID_STORAGE_KEY = 'client_id';

function generateUUIDv4(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    const value = char === 'x' ? random : (random % 4) + 8;

    return value.toString(16);
  });
}

export function getClientId(): string {
  if (typeof window === 'undefined') {
    return 'temp-' + Date.now().toString(36) + Math.random().toString(36).slice(2);
  }

  let clientId = localStorage.getItem(CLIENT_ID_STORAGE_KEY);

  if (!clientId) {
    try {
      if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        clientId = crypto.randomUUID();
      } else {
        clientId = generateUUIDv4();
      }

      localStorage.setItem(CLIENT_ID_STORAGE_KEY, clientId);
    } catch (error) {
      console.error('Failed to generate client ID:', error);
      clientId = generateUUIDv4();
      localStorage.setItem(CLIENT_ID_STORAGE_KEY, clientId);
    }
  }

  return clientId;
}
